<template>
<v-container fluid fill-height>
    <loading v-if="loading"></loading>
    <v-layout v-else>
        <v-flex>
            <v-card>
                <v-layout pa-2>
                    <v-layout column>
                        
                        <v-layout class="mb-4">
                            <v-flex xs12>
                                <h1 class="text-xs-center">Activity Department Codes</h1>
                                <department-codes :loading="loading" :plantID="plantID" />
                            </v-flex>
                        </v-layout>
                        
                        <v-layout class="mb-4">
                            <v-flex xs12>
                                <h1 class="text-xs-center">Activities</h1>
                                <activities :loading="loading" :plantID="plantID" />
                            </v-flex>
                        </v-layout>

                    </v-layout>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
// import ForecastProfiles from '@/components/forecasting/ForecastProfiles.vue';
import DepartmentCodes from '@/components/cropwork/CropWorkDepartmentCodes.vue';
import Activities from '@/components/cropwork/CropWorkActivities.vue';

export default {
    components: {
        Loading,
        DepartmentCodes,
        Activities,
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        // forecastProfiles() {
        //     return this.$store.getters["ForecastingProfileStore/getForecastProfiles"]({});
        // },
        plantID() {
            return this.$route.params.plantID;
        }
    },
    methods: {
        async loadData() {
            this.loading = true;

            Promise.all([
                this.$store.dispatch("CropWorkStore/loadActivityDepartmentCodesAsync", { plantID: this.plantID }),
                this.$store.dispatch("CropWorkStore/loadCropWorkActivitiesAsync", { plantID: this.plantID }),
            ]);

            this.loading = false;
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style>

</style>
